import { Sun } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#2A2B2A] text-white/80" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-sm bg-[#CBA365] text-[#2A2B2A]">
                <Sun className="h-4 w-4" strokeWidth={2.2} />
              </span>
              <span className="font-serif-display text-white text-lg tracking-tight">Loughrea Solar Farm</span>
            </div>
            <p className="mt-4 text-[13.5px] leading-relaxed max-w-md text-white/70">
              A proposed solar energy development by Loughrea Energy Ltd
              (a company of Obton). This website is a public information
              resource for the pre‑planning consultation phase.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-[#CBA365] mb-4">Project</div>
            <ul className="space-y-2 text-[13.5px]">
              <li><a href="#project" className="link-underline">Project overview</a></li>
              <li><a href="#location" className="link-underline">Location</a></li>
              <li><a href="#information" className="link-underline">Assessments</a></li>
              <li><a href="#planning" className="link-underline">Planning process</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-[#CBA365] mb-4">Get involved</div>
            <ul className="space-y-2 text-[13.5px]">
              <li><a href="#book" className="link-underline">Information days</a></li>
              <li><a href="#feedback" className="link-underline">Send us a question</a></li>
              <li><a href="mailto:nre@obton.com" className="link-underline">nre@obton.com</a></li>
              <li><a href="tel:+353873547360" className="link-underline">087‑354 7360</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-[12px] text-white/55">
          <span>© {new Date().getFullYear()} Loughrea Energy Ltd. All information on this site is indicative and provided for consultation purposes.</span>
          <span>Planning application to Galway County Council — Q3 2026</span>
        </div>
      </div>
    </footer>
  );
}
